import {
  TOGGLE_LIGHTBOX,
  SET_LIGHTBOX_IMAGE,
  SET_LIGHTBOX_VIDEO,
  CLEAR_LIGHTBOX_GALLERIES,
  SAVE_LIGHTBOX_GALLERY,
  POPULATE_LIGHTBOX_GALLERY,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  isOpen: false,
  imgId: null,
  imgSrc: '',
  imgAlt: '',
  videoSrc: '',
  isVideo: false,
  galleries: {},
  savedGalleries: [],
  selectedGallery: '',
};

function lightboxReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case TOGGLE_LIGHTBOX: {
      return {
        ...state,
        isOpen: action.bool,
        isVideo: action.isVideo,
      };
    }
    case SET_LIGHTBOX_IMAGE: {
      return {
        ...state,
        selectedGallery: action.galleryId,
        imgId: action.id,
        imgSrc: action.url,
        imgAlt: action.alt,
      };
    }
    case SET_LIGHTBOX_VIDEO: {
      return {
        ...state,
        videoSrc: action.url,
        isYoutube: action.isYoutube,
      };
    }
    case CLEAR_LIGHTBOX_GALLERIES: {
      return {
        ...state,
        galleries: {},
      };
    }
    case POPULATE_LIGHTBOX_GALLERY: {
      let arr = [];
      if(state.galleries[action.galleryId]) {
        arr = state.galleries[action.galleryId];
      }
      return {
        ...state,
        galleries: {
          ...state.galleries,
          [action.galleryId]: [
            ...arr,
            {
              id: action.id,
              imgSrc: action.imgSrc,
              thumbSrc: action.thumbSrc,
              alt: action.alt,
            }
          ],

        }
      };
    }
    case SAVE_LIGHTBOX_GALLERY: {
      return {
        ...state,
        savedGalleries: [
          ...state.savedGalleries,
          action.galleryId,
        ],
      };
    }
    default:
      return state;
  }
}

export default lightboxReducer;

// galleries: [
//     {
//         id: 'vehicle-list',
//         images: [
//             {
//                 imgSrc: 'https://ford-tw-dev.s3.ap-southeast-1.amazonaws.com/images/tmp/vehicles/ford-raptor/0e1245b6-7e35-4efb-8473-0482b08abaa8.jpg',
//                 thumbSrc: 'https://ford-tw-dev.s3.ap-southeast-1.amazonaws.com/images/tmp/vehicles/ford-raptor/thumbnails/.zlB0RWC2.jpg',
//                 alt: 'Ford Raptor'
//             },
//             {
//                 imgSrc: 'https://ford-tw-dev.s3.ap-southeast-1.amazonaws.com/images/tmp/vehicles/ford-raptor/15166781-d43c-4a94-b7d4-382dd7dcf9ac.jpg',
//                 thumbSrc: 'https://ford-tw-dev.s3.ap-southeast-1.amazonaws.com/images/tmp/vehicles/ford-raptor/thumbnails/.toJD2bcN.jpg',
//                 alt: 'Ford Raptor 2'
//             },
//             {
//                 imgSrc: 'https://ford-tw-dev.s3.ap-southeast-1.amazonaws.com/images/tmp/vehicles/ford-raptor/9f363c53-9fb9-4e4b-9b36-b6461edd3b04.jpg',
//                 thumbSrc: 'https://ford-tw-dev.s3.ap-southeast-1.amazonaws.com/images/tmp/vehicles/ford-raptor/thumbnails/.umVTivIZ.jpg',
//                 alt: 'Ford Raptor 3'
//             },
//         ]
//     },
//     {
//         id: 'itinerary-photos',
//         images: [
//             {
//                 imgSrc: 'https://ford-tw-dev.s3.ap-southeast-1.amazonaws.com/images/tmp/vehicles/ford-raptor/0e1245b6-7e35-4efb-8473-0482b08abaa8.jpg',
//                 thumbSrc: 'https://ford-tw-dev.s3.ap-southeast-1.amazonaws.com/images/tmp/vehicles/ford-raptor/thumbnails/.zlB0RWC2.jpg',
//                 alt: 'Ford Raptor'
//             },
//             {
//                 imgSrc: 'https://ford-tw-dev.s3.ap-southeast-1.amazonaws.com/images/tmp/vehicles/ford-raptor/15166781-d43c-4a94-b7d4-382dd7dcf9ac.jpg',
//                 thumbSrc: 'https://ford-tw-dev.s3.ap-southeast-1.amazonaws.com/images/tmp/vehicles/ford-raptor/thumbnails/.toJD2bcN.jpg',
//                 alt: 'Ford Raptor 2'
//             },
//             {
//                 imgSrc: 'https://ford-tw-dev.s3.ap-southeast-1.amazonaws.com/images/tmp/vehicles/ford-raptor/9f363c53-9fb9-4e4b-9b36-b6461edd3b04.jpg',
//                 thumbSrc: 'https://ford-tw-dev.s3.ap-southeast-1.amazonaws.com/images/tmp/vehicles/ford-raptor/thumbnails/.umVTivIZ.jpg',
//                 alt: 'Ford Raptor 3'
//             },
//         ]
//     },
// ],
